import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TextButtonExternalSharedComponent } from './text-button-external.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        TextButtonExternalSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule
    ],
    exports: [
        TextButtonExternalSharedComponent
    ]
})

export class TextButtonExternalSharedModule {}
